import { Link } from "react-router-dom";
import AccountNav from "../components/AccountNav";
import { useAuth } from "../context/AuthContext";
import { formatAccountType } from "../utils/userLabels";

export default function AccountHome() {
  const { user, account_type } = useAuth();

  const openPostProperty = () => {
    window.dispatchEvent(new CustomEvent("fy-open-post-property", { detail: { listingType: "sale", source: "dashboard" } }));
  };

  const joinedOn = user?.created_at
    ? new Date(user.created_at).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric"
    })
    : "-";

  return (
    <div className="container page account-page">
      <div className="account-shell">
        <AccountNav />

        <section className="account-main">
          <div className="account-hero">
            <div>
              <h2>My Account</h2>
              <p>Manage your profile, listings, and daily activity in one place.</p>
            </div>
            <button className="btn btn-strong" type="button" onClick={openPostProperty}>
              Post Property Free
            </button>
          </div>

          <div className="account-grid account-grid--stats">
            <article className="account-card">
              <p className="account-card-label">Name</p>
              <h3>{user?.full_name || "Member"}</h3>
            </article>
            <article className="account-card">
              <p className="account-card-label">Email</p>
              <h3>{user?.email || "-"}</h3>
            </article>
            <article className="account-card">
              <p className="account-card-label">Account Type</p>
              <h3 className="account-role">{formatAccountType(account_type)}</h3>
            </article>
            <article className="account-card">
              <p className="account-card-label">Member Since</p>
              <h3>{joinedOn}</h3>
            </article>
          </div>

          <div className="account-grid">
            <article className="account-card">
              <h3>Quick Actions</h3>
              <div className="account-links">
                <Link to="/account/profile">Update Profile</Link>
                <Link to="/account/listings">Manage My Listings</Link>
                <Link to="/account/activity">View Activity</Link>
              </div>
            </article>

            <article className="account-card">
              <h3>Workspace Info</h3>
              <ul className="account-list">
                <li>Primary market: Kashmir & nearby districts</li>
                <li>Lead notifications: Email and in-app status updates</li>
                <li>Listing workflow: Draft, review, publish</li>
                <li>Security: Session-based authenticated access</li>
              </ul>
            </article>
          </div>
        </section>
      </div>
    </div>
  );
}
